import { CheckCircle2, AlertCircle, Circle, MinusCircle } from "lucide-react";
import { formatEuro } from "@/lib/constants";

const STATUS = {
  paid:    { color: "#2A9D8F", label: "Paid",        Icon: CheckCircle2 },
  partial: { color: "#E76F51", label: "Partial",     Icon: AlertCircle },
  unpaid:  { color: "#D62828", label: "Outstanding", Icon: AlertCircle },
  none:    { color: "#6C757D", label: "No orders",   Icon: MinusCircle },
};

const hexToRgba = (hex, a) => {
  const h = hex.replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r},${g},${b},${a})`;
};

export default function PaymentBadge({ status = "none", balance, compact = false, testId }) {
  const s = STATUS[status] || STATUS.none;
  const Icon = s.Icon;
  return (
    <span
      data-testid={testId || "payment-badge"}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider"
      style={{ backgroundColor: hexToRgba(s.color, 0.15), color: s.color, border: `1px solid ${hexToRgba(s.color, 0.3)}` }}
      title={balance != null ? `Outstanding: ${formatEuro(balance)}` : ""}
    >
      <Icon size={12} />
      {compact ? s.label : `${s.label}${balance != null && balance > 0.001 ? " · " + formatEuro(balance) : ""}`}
    </span>
  );
}
